import * as React from "react";
const SvgFiRrHexagonDivide = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hexagon-divide_svg__a)">
      <path
        fill="#062147"
        d="M13.5 16.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M12 9a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 12 9m11.396 5.364-3.282 6A5.1 5.1 0 0 1 15.624 23H8.393a5.1 5.1 0 0 1-4.485-2.627L.612 14.377A4.9 4.9 0 0 1 .61 9.631l3.297-6.003A5.11 5.11 0 0 1 8.394 1h7.229a5.1 5.1 0 0 1 4.491 2.636l3.28 6c.81 1.48.81 3.248 0 4.728zm-1.756-3.769-3.28-6a3.1 3.1 0 0 0-2.736-1.596H8.395c-1.147 0-2.194.61-2.734 1.591l-3.296 6.004a2.91 2.91 0 0 0 0 2.819l3.296 5.996a3.1 3.1 0 0 0 2.732 1.59h7.231c1.149 0 2.198-.611 2.735-1.595l3.281-6a2.92 2.92 0 0 0 0-2.809M16.999 11H7a1 1 0 1 0 0 2h10a1 1 0 1 0-.001-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hexagon-divide_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHexagonDivide;
